import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Entity Type Role", -1)
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  class: "d-flex justify-content-end",
  "data-kt-role_type-table-toolbar": "base"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_9 = { class: "card-body pt-0" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  class: "modal fade",
  id: "role_type_details",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_20 = { class: "modal-dialog mw-650px" }
const _hoisted_21 = { class: "modal-content" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header bg-primary",
  id: "kt_modal_add_type_role_header"
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-light" }, "Add Entity Type Role"),
  /*#__PURE__*/_createElementVNode("div", {
    id: "kt_modal_add_type_role_close",
    "data-bs-dismiss": "modal",
    class: "btn btn-icon btn-sm btn-active-icon-primary"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
  ])
], -1)
const _hoisted_23 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_24 = { class: "table-responsive mt-5" }
const _hoisted_25 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Role Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Role Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Role Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Level")
  ])
], -1)
const _hoisted_27 = { class: "fw-bold" }
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "fw-bold" }
const _hoisted_30 = { class: "fw-bold" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_TypeRoleModal = _resolveComponent("TypeRoleModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-15",
              placeholder: "Search Entity Type Role"
            }, null, 544), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args))),
              type: "button",
              class: "btn btn-primary",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_add_type_role"
            }, [
              _hoisted_8,
              _createTextVNode(" Add Entity Type Role ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true
        }, {
          "cell-sl": _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.id), 1)
          ]),
          "cell-type": _withCtx(({ row: role_type }) => [
            _createTextVNode(_toDisplayString(role_type.role_type), 1)
          ]),
          "cell-role_name": _withCtx(({ row: role_type }) => [
            _createTextVNode(_toDisplayString(role_type.role_name), 1)
          ]),
          "cell-role_title": _withCtx(({ row: role_type }) => [
            _createTextVNode(_toDisplayString(role_type.role_title), 1)
          ]),
          "cell-level": _withCtx(({ row: role_type }) => [
            _createTextVNode(_toDisplayString(role_type.level), 1)
          ]),
          "cell-actions": _withCtx(({ row: role_type }) => [
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.view(role_type)),
              "data-bs-toggle": "modal",
              "data-bs-target": "#role_type_details",
              class: "btn btn-icon btn-role_title-light btn-active-color-primary btn-sm me-1"
            }, _hoisted_12, 8, _hoisted_10),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.edit(role_type)),
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_add_type_role",
              class: "btn btn-icon btn-role_title-light btn-active-color-primary btn-sm me-1"
            }, _hoisted_15, 8, _hoisted_13),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.Delete(role_type.id)),
              class: "btn btn-icon btn-role_title-light btn-active-color-primary btn-sm"
            }, _hoisted_18, 8, _hoisted_16)
          ]),
          _: 1
        }, 8, ["table-data", "table-header"])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("table", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.data.role_type), 1),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.data.role_name), 1),
                    _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.data.role_title), 1),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.data.level), 1)
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_31
        ])
      ])
    ]),
    _createVNode(_component_TypeRoleModal)
  ], 64))
}